module.exports = __webpack_public_path__ + "img/tab-water-alarm.68c5846c.png";